import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

const Hero = () => {
    const banners = [
        { title: "ADSS CABLE ACCESSORIES", desc: "Leading Manufacturer in India", img: "/banner1.jpg" },
    ];

    return (
        <section className="relative w-full">
            <Carousel
                autoPlay={true}
                infiniteLoop={true}
                showThumbs={false}
                showStatus={false}
                interval={4000}
                stopOnHover={false}
                swipeable={true}
                emulateTouch={true}
                showArrows={true}
            >
                {banners.map((banner, index) => (
                    <div key={index} className="h-[300px] md:h-[750px] relative">
                        <img src={banner.img} alt={banner.title} className="h-full w-full object-cover" />

                        {/* Text Overlay */}
                        <div className="absolute inset-0 flex flex-col justify-center items-start px-6 md:px-20 bg-black/40">
                            <h1 className="text-2xl md:text-6xl font-extrabold text-white leading-tight drop-shadow-lg text-left">
                                {banner.title}
                            </h1>
                            <p className="text-sm md:text-2xl text-white mt-2 md:mt-4 drop-shadow-md text-left">
                                {banner.desc}
                            </p>
                        </div>
                    </div>
                ))}
            </Carousel>
        </section>
    );
};

export default Hero;